import { PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID } from 'owa-folders-constants';
import getFolderTreeCurrentLoadedIndex from '../selectors/getFolderTreeCurrentLoadedIndex';
import { getApolloClient } from 'owa-apollo';
import {
    FetchPrimaryMailFoldersDocument,
    FetchPrimaryMailFoldersQuery,
    FetchPrimaryMailFoldersQueryVariables,
} from './__generated__/fetchPrimaryMailFolders.interface';

import { shouldShowFolder } from 'owa-folders-data-utils';
import type * as Schema from 'owa-graph-schema';

/**
 * Makes a service call to fetch the primary mail folders.
 * Do not call this directly, consider calling getPrimaryMailFolders.
 */
export async function fetchPrimaryMailFolders(mailboxInfo: Schema.MailboxInfoInput) {
    const offset = getFolderTreeCurrentLoadedIndex(PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID);
    const apolloClient = await getApolloClient();

    const primaryFolderHierarchyResponse = await apolloClient.query<
        FetchPrimaryMailFoldersQuery,
        FetchPrimaryMailFoldersQueryVariables
    >({
        query: FetchPrimaryMailFoldersDocument,
        variables: {
            baseFolderDistinguishedIds: [PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID],
            offset: offset,
            mailboxInfo: mailboxInfo,
            shouldShowJunkEmailFolder: shouldShowFolder('junkemail'),
            shouldShowNotesFolder: shouldShowFolder('notes'),
        },
    });

    return primaryFolderHierarchyResponse.data.folderHierarchy;
}
